
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11412",
                "data-name": "矩形 11412",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(0.3 0)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_349",
        "data-name": "蒙版组 349",
        "class": "cls-2",
        "transform": "translate(-0.3 0)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "weishengjian",
            "class": "cls-3",
            "d": "M101.482,5.76a1.006,1.006,0,0,1,.977.708l.018.074,1.646,7.68a.922.922,0,0,1-.192.762,1.029,1.029,0,0,1-.728.372l-.075,0h-.805v2.806A1.023,1.023,0,0,1,101.31,19.2H99.284a1.023,1.023,0,0,1-1.013-1.034V15.36h-.805a1.067,1.067,0,0,1-.125-.007l-.062-.01a.969.969,0,0,1-.82-1.049l.011-.071,1.646-7.68a1,1,0,0,1,.915-.78l.081,0Zm-7.468,0a1.036,1.036,0,0,1,.78.347.924.924,0,0,1,.216.79l-1.8,6.543v4.32a.987.987,0,0,1-1.013.96H90.171a.987.987,0,0,1-1.013-.96V13.44L87.357,6.9a.924.924,0,0,1,.216-.79,1.036,1.036,0,0,1,.779-.347Zm6.8,9.6h-1.03l-.05,0a.49.49,0,0,0-.447.477v1.92a.494.494,0,0,0,.506.48H100.8a.494.494,0,0,0,.506-.48V15.84a.493.493,0,0,0-.5-.48ZM91.69,13.44H90.677a.494.494,0,0,0-.506.48v3.36a.494.494,0,0,0,.506.48H91.69a.494.494,0,0,0,.506-.48V13.92A.494.494,0,0,0,91.69,13.44Zm9.379-6.72H99.526a.5.5,0,0,0-.481.33L99.03,7.1l-1.44,6.72a.461.461,0,0,0,.086.377.512.512,0,0,0,.351.2l.059,0h4.422l.051,0,.05-.007a.485.485,0,0,0,.4-.51L103,13.824l-1.44-6.72a.5.5,0,0,0-.5-.384Zm-7.716,0H89.015a.517.517,0,0,0-.4.188.46.46,0,0,0-.087.417l1.371,4.8a.5.5,0,0,0,.489.355H91.98a.5.5,0,0,0,.489-.355l1.371-4.8a.46.46,0,0,0-.087-.417A.517.517,0,0,0,93.352,6.72ZM91.183,0a2.468,2.468,0,0,1,2.532,2.4,2.535,2.535,0,0,1-5.063,0A2.468,2.468,0,0,1,91.183,0ZM100.3,0a2.468,2.468,0,0,1,2.532,2.4,2.535,2.535,0,0,1-5.063,0A2.468,2.468,0,0,1,100.3,0ZM91.183.96A1.481,1.481,0,0,0,89.664,2.4a1.521,1.521,0,0,0,3.038,0A1.481,1.481,0,0,0,91.183.96Zm9.114,0A1.481,1.481,0,0,0,98.778,2.4a1.521,1.521,0,0,0,3.038,0A1.481,1.481,0,0,0,100.3.96Z",
            "transform": "translate(-83.74 2.4)"
          }
        }
      ]
    }
  ]
})
    }
  